import type { AiContentReportReason } from '@orborix/shared-types';
import type { UiLocale } from '../../screens/conversation/coachCatalog.js';

/**
 * Copy of the "report this reply" flag (Google Play AI-Generated Content
 * policy, Apple 1.2). Spanish first (rioplatense, voseo); the English pair is
 * ready for when the UI has a locale.
 */
export interface AiReportCopy {
  buttonLabel: string;
  title: string;
  subtitle: string;
  reasons: ReadonlyArray<{ id: AiContentReportReason; label: string }>;
  commentLabel: string;
  commentPlaceholder: string;
  submit: string;
  sending: string;
  cancel: string;
  pickReason: string;
  sent: string;
  error: string;
  rateLimited: string;
}

export const AI_REPORT_COPY: Record<UiLocale, AiReportCopy> = {
  es: {
    buttonLabel: 'Reportar esta respuesta',
    title: 'Reportar respuesta',
    subtitle: 'La revisa una persona del equipo de Orborix.',
    reasons: [
      { id: 'offensive', label: 'Ofensiva o inapropiada' },
      { id: 'incorrect', label: 'Información incorrecta' },
      { id: 'other', label: 'Otro' },
    ],
    commentLabel: 'Comentario (opcional)',
    commentPlaceholder: 'Contanos qué pasó',
    submit: 'Enviar reporte',
    sending: 'Enviando…',
    cancel: 'Cancelar',
    pickReason: 'Elegí un motivo para enviar.',
    sent: 'Gracias, recibimos tu reporte.',
    error: 'No pudimos enviar el reporte. Probá de nuevo.',
    rateLimited: 'Enviaste muchos reportes seguidos. Probá en un rato.',
  },
  en: {
    buttonLabel: 'Report this reply',
    title: 'Report reply',
    subtitle: 'Someone on the Orborix team reviews it.',
    reasons: [
      { id: 'offensive', label: 'Offensive or inappropriate' },
      { id: 'incorrect', label: 'Incorrect information' },
      { id: 'other', label: 'Other' },
    ],
    commentLabel: 'Comment (optional)',
    commentPlaceholder: 'Tell us what happened',
    submit: 'Send report',
    sending: 'Sending…',
    cancel: 'Cancel',
    pickReason: 'Pick a reason to send it.',
    sent: 'Thanks, we got your report.',
    error: 'We could not send the report. Try again.',
    rateLimited: 'You sent many reports in a row. Try again later.',
  },
};
